import { render, staticRenderFns } from "./dictList.vue?vue&type=template&id=227aa292&scoped=true"
import script from "./dictList.vue?vue&type=script&lang=js"
export * from "./dictList.vue?vue&type=script&lang=js"
import style0 from "./dictList.vue?vue&type=style&index=0&id=227aa292&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227aa292",
  null
  
)

export default component.exports